import React from 'react';
import { useBunkerContext } from 'src/context/BunkerContext';
import { BunkerLoss } from 'src/types/ViewModel/Bunkering/BunkerLoss';
import { Tank } from 'src/types/ViewModel/Vessel/Tank';
import { ListButton } from 'src/styles/button.style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BunkeringRegListItemStyle } from '../Bunkering.styles';
import { getBunkerLossReasonText } from 'src/types/ViewModel/Bunkering/BunkerLossReason';
import { BunkerLossTableStyle } from './BunkerRob.styles';

interface BunkerLossProps {
    bunkerLossData: BunkerLoss[];
    fuelTanks: Tank[];
    selectedBunkerLoss?: BunkerLoss | null;
    deleteBunkerLoss: (bunkerLoss: BunkerLoss, e: React.MouseEvent) => void;
    selectBunkerLoss: (bunkerLoss: BunkerLoss) => void;
}

const BunkerLossList: React.FC<BunkerLossProps> = ({ bunkerLossData, fuelTanks, selectedBunkerLoss, deleteBunkerLoss, selectBunkerLoss }) => {
    const { bunkerings } = useBunkerContext();
    return (
        <BunkerLossTableStyle>
            <thead>
                <tr>
                    <th>Bunker ref.</th>
                    <th>Tank</th>
                    <th>Reason</th>
                    <th>Loss (MT)</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {bunkerLossData.map((loss) => (
                    <BunkeringRegListItemStyle
                        key={`${loss.noonReportId}_${loss.bunkeringGuid}_${loss.tankId}`}
                        selected={selectedBunkerLoss?.bunkerLossGuid === loss.bunkerLossGuid}
                        onClick={() => selectBunkerLoss(loss)}
                    >
                        <td>{bunkerings.find((b) => b.bunkeringGuid === loss.bunkeringGuid)?.bunkeringReference}</td>
                        <td>{fuelTanks.find((t) => t.tankId === loss.tankId)?.tankName}</td>
                        <td>{getBunkerLossReasonText(loss.reason)}</td>
                        <td>{loss.quantityMT}</td>
                        <td>
                            <ListButton onClick={(e) => deleteBunkerLoss(loss, e)}>
                                <FontAwesomeIcon title="Delete loss entry" icon="trash" />
                            </ListButton>
                        </td>
                    </BunkeringRegListItemStyle>
                ))}
            </tbody>
        </BunkerLossTableStyle>
    );
};

export default BunkerLossList;
